import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import ModalActions from '../../../../actions/ModalActions';
import { AccountPages, keyGoPaymentCardStatus } from '../../../../constants/AppConstants';
import urls from '../../../../urls';
import { routerShape } from 'react-router/lib/PropTypes';

import BaseModal from '../../../general/BaseModal';
import Icon from '../../../general/Icon';
import FormattedHTMLMessage from '../../../general/FormattedHTMLMessage';

export class KeyGoCardExpireModal extends React.PureComponent {
    static propTypes = {
        router: routerShape,
        onClose: PropTypes.func,
        onContinue: PropTypes.func,
        cardStatus: PropTypes.string.isRequired,
    };

    static defaultProps = {
        onClose: _.noop,
        onContinue: _.noop,
        cardStatus: keyGoPaymentCardStatus.EXPIRES_THIS_MONTH
    };

    _handleClose = () => {
        ModalActions.close();
    };

    _handlePaymentDetails = () => {
        this.props.router.push(urls.location(AccountPages.SMARTCARD_KEYGO));
        ModalActions.close();
    };

    render() {
        const modalProps = {
            onClose: this._handleClose,
            onContinue: this._handlePaymentDetails,
            closeText: 'button.text.close',
            continueText: 'button.text.updatePaymentDetails',
            className: 'modal--standard modal--xs',
            titleText: 'account.smartcard.keygo.cardExpire.heading',
            disableEscape: true
        };
        return (
            <BaseModal { ...modalProps } >
                <div className="padding-top padding-bottom padding--horiz">
                    <section className="text-center">
                        <Icon icon="warning" className="keygo-card-payment-status__icon" />
                        <div className="text-justify">
                            <FormattedHTMLMessage
                                message={ this.props.cardStatus === keyGoPaymentCardStatus.EXPIRES_THIS_MONTH ?
                                    'account.smartcard.keygo.cardExpire.pending' :
                                    'account.smartcard.keygo.cardExpire.expired' }
                            />
                        </div>
                    </section>
                </div>
            </BaseModal>
        );
    }
}

export default KeyGoCardExpireModal;
